import { Box } from '@mantine/core';
import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/publisher/_publisher')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'sidebar.publishers' },
  },
});

function RouteComponent() {
  return (
    <Box p="md">
      <Outlet />
    </Box>
  );
}
